module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "maxWidth": "700px",
      "minHeight": "800px"
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "0 80px"
    }
  }, [_c('div', [_c('h1', [_vm._v("Update Keywords")])]), _vm._v(" "), _c('div', {
    staticClass: "flex row justify-center"
  }, [_c('p', {
    staticClass: "row pl-subheading"
  }, [_vm._v("\n        A refined word cloud is better. We recommend removing "), _c('br'), _vm._v("\n        keywords that are too generic to provide relevant insights.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "user-container",
    staticStyle: {
      "width": "93%",
      "margin-top": "10px"
    }
  }, [_c('table', {
    staticStyle: {
      "width": "97%",
      "text-align": "center"
    }
  }, [_c('tr', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('th', [_vm._v("Included?")]), _vm._v(" "), _c('th', [_vm._v("Keyword")]), _vm._v(" "), _c('th', [_vm._v("Occurrences")])]), _vm._v(" "), _vm._l((Object.keys(_vm.keywords)), function(word) {
    return _c('tr', {
      staticClass: "border_bottom",
      staticStyle: {
        "height": "40px"
      }
    }, [(word !== 'l') ? _c('td', [_c('pl-checkbox', {
      staticStyle: {
        "margin-left": "50px"
      },
      on: {
        "click": function($event) {
          _vm.keywords[word]['removed'] = !_vm.keywords[word]['removed']
        }
      },
      model: {
        value: (_vm.keywords[word]['removed']),
        callback: function($$v) {
          _vm.$set(_vm.keywords[word], 'removed', $$v)
        },
        expression: "keywords[word]['removed']"
      }
    })], 1) : _vm._e(), _vm._v(" "), (word !== 'l') ? _c('td', [_vm._v(_vm._s(word))]) : _vm._e(), _vm._v(" "), (word !== 'l') ? _c('td', [_vm._v(_vm._s(_vm.keywords[word]['freq']))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "30px"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "width": "50%"
    },
    on: {
      "click": function($event) {
        return _vm.closeMenu()
      }
    }
  }, [_c('pl-button', [_vm._v("Cancel")])], 1), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    },
    on: {
      "click": function($event) {
        return _vm.sendDataBack()
      }
    }
  }, [_c('pl-button', {
    staticClass: "pl-primary"
  }, [_vm._v("Save and Update Word Cloud")])], 1)])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0557696c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineRoundtables/components/roundtableSummary/roundtableNlpWordCloudEditKeywords.vue
// module id = 1245
// module chunks = 61